module.exports = __webpack_public_path__ + "static/media/staringLive.de2c498a.svg";